import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SfClockArrowCirclepathIcon = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [/*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M13.053 22.205c5.595 0 10.245-4.65 10.245-10.245 0-5.605-4.65-10.246-10.245-10.246-5.605 0-10.246 4.63-10.246 10.236h1.708c0-4.741 3.797-8.518 8.538-8.518a8.497 8.497 0 0 1 8.538 8.528c0 4.74-3.797 8.558-8.538 8.538a8.502 8.502 0 0 1-6.911-3.536c-.311-.412-.784-.542-1.205-.291-.402.25-.513.803-.171 1.245 1.908 2.562 4.902 4.29 8.287 4.29ZM1.572 10.021c-.724 0-.904.492-.513 1.055l2.25 3.194c.332.462.814.452 1.135 0l2.25-3.204c.382-.553.201-1.045-.512-1.045h-4.61Z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M12.832 5.963a.943.943 0 0 0-.945.944v5.696c0 .24.07.472.272.723l2.43 3.214c.402.523.945.613 1.437.281.452-.311.482-.884.13-1.376l-3.485-4.73 1.115 3.434V6.907a.952.952 0 0 0-.954-.944Z"
  })]
});
export default SfClockArrowCirclepathIcon;